// extracted by mini-css-extract-plugin
export default {"Reports":"Reports_Reports__X8iPG","Center":"Reports_Center__4AglZ","UserClick":"Reports_UserClick__uWRoK"};